import { SlotGameType1 } from "../SlotGameType1";

export class GenericGame1 extends SlotGameType1
{
}